import React from 'react';
import { Box, Container } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

export function ViewLoading() {
  return (
    <Container
      style={{
        background: '#f7f9ff',
        padding: '16px',
      }}
      maxWidth="sm"
    >
      <Skeleton variant="rect" height={100} style={{ marginBottom: 16 }} />
      <Skeleton variant="rect" height={60} style={{ marginBottom: 8 }} />
      <Skeleton height={40} />
      <Skeleton height={40} />
      <Skeleton height={40} />
      <Skeleton height={40} />
      <Skeleton height={40} animation="wave" />
    </Container>
  );
}
